import { updateAxiosAccessToken } from 'api/axiosClient';
import maintainerApi from 'api/maintainerApi';
import PreferenceKeys from 'general/constants/PreferenceKeys';
import ToastHelper from 'general/helpers/ToastHelper';

const { createSlice, createAsyncThunk } = require('@reduxjs/toolkit');

// ---- thunks ----
// dang nhap admin/agency
export const thunkLogIn = createAsyncThunk('maintainerAuth/thunkLogIn', async (params, thunkAPI) => {
  try {
    const res = await maintainerApi.signIn(params);
    return res;
  } catch (error) {
    return {
      result: 'failed',
      reason: error?.response?.data?.reason ?? 'Đăng nhập không thành công',
    };
  }
});

// dang nhap maintainer
export const thunkLogInMaintainer = createAsyncThunk('maintainerAuth/thunkLogIn', async (params, thunkAPI) => {
  try {
    const res = await maintainerApi.signIn(params);
    return res;
  } catch (error) {
    return {
      result: 'failed',
      reason: error?.response?.data?.reason ?? 'Đăng nhập không thành công',
    };
  }
});

// ---- params ----
const initialState = {
  isLoggingIn: false,
  maintainer: {},
  maintainerPermissionList: [],
};

const maintainerAuthSlice = createSlice({
  name: 'maintainerAuth',
  initialState,
  reducers: {
    resetMaintainerAuthSlice: (state, action) => {
      return initialState;
    },
    updateMaintainer: (state, action) => {
      state.maintainer = action.payload ?? {};
    },
    setMaintainerPermissionList: (state, action) => {
      state.maintainerPermissionList = action.payload ?? '';
    },
  },
  extraReducers: {
    // dang nhap
    [thunkLogIn.pending]: (state, action) => {
      state.isLoggingIn = true;
    },
    [thunkLogIn.rejected]: (state, action) => {
      state.isLoggingIn = false;
    },
    [thunkLogIn.fulfilled]: (state, action) => {
      state.isLoggingIn = false;
      const { result, maintainer, reason } = action.payload;
      if (result == 'success') {
        let token = maintainer?.token;
        localStorage.setItem(PreferenceKeys.maintainerAccessToken, token);
        localStorage.setItem(PreferenceKeys.savedMaintainerLoginEmail, maintainer?.email);
        updateAxiosAccessToken(token);
        state.maintainer = maintainer ?? {};

        const maintainerPermissionList = maintainer?.permissionGroup?.permissions?.map((permission) => {
          return { path: permission.fe_path, code: permission.code };
        })
        state.maintainerPermissionList = maintainerPermissionList;
      } else {
        ToastHelper.showError(reason);
      }
    },
  },
});

const { reducer, actions } = maintainerAuthSlice;
export const { resetMaintainerAuthSlice, updateMaintainer, setMaintainerPermissionList } = actions;
export default reducer;
